import http from "@/services/http";
import {
  CustomerContractDetail,
  CustomerContractListItem,
  CustomerLoanDetail,
  CustomerLoanListItem,
} from "@/models/customerPortal.model";

const RAW_API_BASE_URL = process.env.VUE_APP_API_URL || "/api";

const getAssetBaseUrl = (): string => {
  if (!RAW_API_BASE_URL) {
    return typeof window !== "undefined" ? window.location.origin : "";
  }

  if (/^https?:\/\//i.test(RAW_API_BASE_URL)) {
    return RAW_API_BASE_URL.replace(/\/api\/?$/i, "/");
  }

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return "";
};

const resolveAssetUrl = (value?: string | null): string => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(https?:)?\/\//i.test(raw) || /^(data|blob):/i.test(raw)) return raw;

  const base = getAssetBaseUrl();
  if (!base) return raw;

  try {
    return new URL(raw, base).toString();
  } catch {
    return raw;
  }
};

const normalizeVehicleImages = (images: any[] = []) =>
  images.map((image) => ({
    ...image,
    imageUrl: resolveAssetUrl(image?.imageUrl),
  }));

class CustomerService {
  async listLoans(): Promise<CustomerLoanListItem[]> {
    const response = await http.get<CustomerLoanListItem[]>("/customer/loans");
    return Array.isArray(response) ? response : [];
  }

  async getLoanById(loanId: string): Promise<CustomerLoanDetail> {
    const response = await http.get<CustomerLoanDetail>(`/customer/loans/${loanId}`);
    return {
      ...response,
      schedule: Array.isArray(response?.schedule) ? response.schedule : [],
      payments: Array.isArray(response?.payments) ? response.payments : [],
    };
  }

  async listContracts(): Promise<CustomerContractListItem[]> {
    const response = await http.get<CustomerContractListItem[]>("/customer/contracts");
    return Array.isArray(response) ? response : [];
  }

  async getContractById(contractId: string): Promise<CustomerContractDetail> {
    const response = await http.get<CustomerContractDetail>(`/customer/contracts/${contractId}`);
    return {
      ...response,
      vehicle: response?.vehicle
        ? {
            ...response.vehicle,
            images: normalizeVehicleImages(
              Array.isArray(response.vehicle.images) ? response.vehicle.images : [],
            ),
          }
        : null,
      deferredDownPayments: Array.isArray(response?.deferredDownPayments)
        ? response.deferredDownPayments
        : [],
    };
  }
}

export default new CustomerService();
